import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core'
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight'

@Component({
  selector: 'li[cft-holy-grail-grid-sidenav-submenu-item]',
  template: `
    <a class="block w-full px-2xs py-xs" [routerLink]="path">
      {{ label }}
    </a>
    <span class="px-xs text-president-400">
      <fa-icon [icon]="caretIcon"></fa-icon>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../../styles/app-reference.css';

    :host {
      @apply flex items-center justify-between border-b border-grey-300 bg-grey-50 text-sm font-medium hover:bg-grey-100 hover:text-president-400;
    }
  `,
})
export class HolyGrailGridSidenavSubmenuItemComponent {
  @Input() label!: string
  @Input() path!: string
  @Output() showSubMenu = new EventEmitter()
  @Output() hideSubMenu = new EventEmitter()
  protected readonly caretIcon = faCaretRight

  constructor(readonly element: ElementRef) {}

  @HostListener('mouseenter')
  mouseEnter() {
    this.showSubMenu.emit()
  }

  @HostListener('mouseleave')
  mouseLeave() {
    this.hideSubMenu.emit()
  }
}
